import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../../Zemplin/General/Title';
import InfoRow from './InfoRow';
import { IconImg, TextP } from '../../..';
import { ProductDetailPriceCart } from './ProductDetailPriceCart';
import * as dogSrc from '../../../../assets/dsi/dog.svg';
import * as shareSrc from '../../../../assets/dsi/share.svg';

interface Props {
  inPackage: number;
  price: number;
  oldPrice: number;
  currency: string;
  avail_id: number;
  availability: string;
  count: number;
  addToCart: any;
  title: string;
  brand: any;
  plu: string;
  ean: string;
  sale: boolean;
  salePercentage: number;
  description: string;
  handleCountChange: (newValue) => void;
}

function RightUpper({
  inPackage,
  price,
  oldPrice,
  currency,
  avail_id,
  availability,
  addToCart,
  handleCountChange,
  count,
  title,
  brand,
  plu,
  ean,
  sale,
  salePercentage,
  description,
}: Props) {
  return (
    <Wrapper>
      <InfoWrapper>
        <Title marginTop={0} marginBottom={16}>
          {title}
        </Title>
        <Description>{`${description}`}</Description>
        <InfoRow title={__('Výrobca')} value={`${inPackage} ${brand}`} />
        <InfoRow title={__('Záruka')} value={`${24} mesiacov`} />
        <InfoRow title={__('Kód tovaru')} value={`${plu}`} />
        <InfoRow noBorderBottom={true} title={__('EAN kód')} value={`${ean}`} />
        {/*<PriceInfo price={price} currency={currency} />*/}
        {/*<BigButtonWithRequest*/}
        {/*  onRequestClick={addToRequest}*/}
        {/*  onButtonClick={addToCart}*/}
        {/*  disabled={onStock === 0}*/}
        {/*/>*/}
      </InfoWrapper>
      <ProductDetailPriceCart
        price={price}
        oldPrice={oldPrice}
        sale={sale}
        salePercentage={salePercentage}
        avail_id={avail_id}
        availability={availability}
        currency={currency}
        count={count}
        handleCountChange={handleCountChange}
        addToCart={addToCart}
      />
      <WatchShare>
        <WatchShareItem to={''}>
          <IconImg src={dogSrc.toString()} />
          <DogText>Strážny pes</DogText>
        </WatchShareItem>
        <WatchShareItem to={''}>
          <IconImg src={shareSrc.toString()} />
          <ShareText>Zdieľať s priateľmi</ShareText>
        </WatchShareItem>
      </WatchShare>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(600)};
`;

const InfoWrapper = styled(FlexCol)`
  padding: ${rem(24)};
  border-left: ${({ theme }) => theme.borders.primary};

  ${({ theme }) => theme.mediab.l925`
    padding: 0;
    border: 0;
    box-shadow: none;
  `}
`;

const Description = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const WatchShare = styled(FlexRowCenterVertical)`
  padding: ${rem(16)};
  justify-content: space-between;
`;

const WatchShareItem = styled(Link)`
  display: flex;
  flex-direction: row;
`;

const ShareText = styled(TextP)`
  font-size: ${rem(16)};
  margin-left: ${rem(8)};
`;

const DogText = styled(ShareText)`
  font-weight: 500;
`;

export { RightUpper as DsiRightUpper };
